import ServiceApi from "../services/service.api";
import ServiceStorage from "./../services/service.storage";
const baseServiceUrl = `/api/v1/Home`;


const ApiHome = {
  getInfos: () => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params: { a: 1 } });
  },
  getMenu: (params) => {
    //console.log("params==========", params);
    const url = `${baseServiceUrl}/getMenu`;
   // console.log("set token : ", ServiceStorage.getAccessToken());
    return ServiceApi.get(url, params);
  },
};

export default ApiHome;